import { ProductListListPath, ProductListProductListPath } from '@/modules/product/paths';
import { Navigate, useParams } from 'react-router-dom';

const ProductListProductAdd = () => {
  const { productListId } = useParams();

  return (
    <Navigate
      to={
        productListId
          ? ProductListProductListPath.withProductListId(productListId)
          : ProductListListPath
      }
      replace
    />
  );
};

export default ProductListProductAdd;
